import { PageHeader } from "@/components/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useQueryParams } from "@/hooks/use-query-params";
import AccessControlPage from "@/pages/access-control";
import ChangelogsPage from "@/pages/changelogs";
import KnowledgeBase from "@/pages/knowledge-base";
import NotionSync from "@/pages/notion-sync";
import SettingsPage from "@/pages/settings";

export default function BackofficePage() {
  const { getParam, setParam } = useQueryParams();
  const activeTab = getParam("tab") || "access-control";
  const setActiveTab = (tab: string) => setParam("tab", tab);

  return (
    <div className="flex flex-col gap-6 pb-8" data-testid="page-backoffice">
      <PageHeader title="Backoffice" />

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList data-testid="backoffice-tabs">
          <TabsTrigger value="access-control" data-testid="tab-access-control">
            Controle de Acessos
          </TabsTrigger>
          <TabsTrigger value="settings" data-testid="tab-settings">
            Configurações
          </TabsTrigger>
          <TabsTrigger value="changelogs" data-testid="tab-changelogs">
            Changelogs
          </TabsTrigger>
          <TabsTrigger value="knowledge-base" data-testid="tab-knowledge-base">
            Base de Conhecimento
          </TabsTrigger>
          <TabsTrigger value="notion-sync" data-testid="tab-notion-sync">
            Sync Notion
          </TabsTrigger>
        </TabsList>

        <TabsContent value="access-control" className="mt-4">
          <AccessControlPage embedded />
        </TabsContent>
        <TabsContent value="settings" className="mt-4">
          <SettingsPage embedded />
        </TabsContent>
        <TabsContent value="changelogs" className="mt-4">
          <ChangelogsPage embedded />
        </TabsContent>
        <TabsContent value="knowledge-base" className="mt-4">
          <KnowledgeBase embedded />
        </TabsContent>
        <TabsContent value="notion-sync" className="mt-4">
          <NotionSync embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
